<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="SalesData"
                :alvqa="alvqa"
            />
            <ImportButton
                :items="importOptions"
                context="FileImport"
                :additionalFunction="setImporterSourceAlvId"
                :alvqa="alvqa"
            />
            <ReportButton
                :items="reportOptions"
                context="FileReport"
                :alvqa="alvqa"
                cols="2"
            />
            <v-col 
                v-if="totalRecords !== null"
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats context="SalesData" typeStats="LIST" alvqa="label-sales_data-list" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ImportButton from '@/components/_buttons/ImportButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ReportButton from '@/components/_buttons/ReportButton'

export default {
    name: 'SalesDataTopSlot',
    components: {
        ImportButton,
        BaseHeaderStats,
        ActionDropdown,
        ReportButton,
    },
    data() {
        return {
            alvqa: "label-sales-data"
        }
    },
    computed: {
        totalRecords() { return this.$store.getters.getTotalRecords },
        
        importOptions(){
            const items = this.$store.getters.getSalesDataImportOptions || []
            items
                .forEach(item=>item.alvqa = `${this.alvqa}-list-import-dropdown-${item.alvId}`);
            return items
        },
        actions() {
            return [
                {
                    text: this.$t('lang_GENERAL_ACTION_OPTION_UPDATE_ERROR_LIST'),
                    value: 'runErrorLists',
                    alvqa: this.alvqa + '-list-action-dropdown-run-error-list'
                },
                {
                    text: this.$t('lang_GENERAL_ACTION_OPTION_EXPORT_ERROR_LIST'), 
                    value: 'downloadErrorList',
                    alvqa: this.alvqa + '-list-action-dropdown-export-error-list'
                },
                {   text: this.$t('lang_GENERIC_ACTION_CREATE_INVOICE'), 
                    value: 'createFromSalesData', 
                    alvqa: this.alvqa + '-list-action-dropdown-create-invoice'
                },
                { 
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE'),
                    value: 'move', 
                    alvqa: this.alvqa + '-list-action-dropdown-move'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        },
        reportOptions() {
            return [
                {
                    text: this.$t('lang_LABEL_SALES_DATA_CAPTION_REPORT_GEMA_TAS_2026'),
                    value: 'gemaTas2026Report',
                    alvqa: this.alvqa + '-list-report-dropdown-gema-tas-2026'
                }
            ]
        },

        setImporterSourceAlvId() {
            let selected = this.$store.getters.getSelectedFileImport
            let options = this.$store.getters.getSalesDataImportOptions
            if (options) {
                let found = options.find(el => el.value == selected)
                if (found) {
                    // set AlvId of Source in store module
                    this.$store.commit('setSalesDataDetailsAlvIdOfSource', found.alvId)
                    this.$store.commit('setSalesDataDetailsFileExtensions', found.fileExtensions)
                }
            } 
        },
    },
    created() {
        this.$store.dispatch('fetchSalesDataImporters')
    }
}
</script>
